export default [
  {
    title: "布局组件",
    list: [
      {
        type: "gridtable",
        label: "设计子表",
        icon: "learun-icon-array-table",
        span: 24,
        isAddBtn: true,
        addBtnText: "新增一行",
        isRemoveBtn: true,
        isDetailBtn: false,
        detailUrl: '',
        isShowNum: true,
        showSummary: false,
        rows: 0, // 默认展示行数
        dataSource: [],
        children: [],
        changeDataEvent: "",
        isDESC: false,
      },
      {
        type: "card",
        label: "卡片布局",
        icon: "learun-icon-card-layout",
        span: 24,
        children: [],
        shadow: "",
      },
      {
        type: "collapse",
        label: "折叠面板",
        icon: "learun-icon-collapse",
        span: 24,
        active: "0",
        tabList: [
          {
            text: "折叠面板一",
            children: [],
          },
        ],
        shadow: "",
      },
      {
        type: "tab",
        label: "选项卡",
        icon: "learun-icon-tab",
        span: 24,
        active: "0",
        tabList: [
          {
            text: "选项卡一",
            children: [],
          },
        ],
        shadow: "",
      },
      {
        type: "tableLayout",
        label: "表格布局",
        icon: "learun-icon-view-form",
        span: 24,
        borderWidth: 1,
        borderColor: "#ddd",
        verticalCenter: false, //竖直居中
        horizontallyCentered: false, //水平居中
        myclass: "",
        cols: [
          {
            prop: "c1",
          },
          {
            prop: "c2",
          },
        ],
        cells: [
          {
            colId: "c1",
            rowIndex: 0,
            rowspan: 1,
            colspan: 1,
            children: [],
          },
          {
            colId: "c2",
            rowIndex: 0,
            rowspan: 1,
            colspan: 1,
            children: [],
          },
        ],
      },
      {
        type: "divider",
        label: "分割线",
        html: "分割线",
        contentPosition: "center",
        icon: "learun-icon-parting-line",
        span: 24,
        labelWidth: 0,
        display: true,
        unRepeated: false,
        fontSize: 16,
        color: "#000000",
      },
      {
        type: "title",
        label: "",
        icon: "learun-icon-typeface",
        span: 24,
        labelWidth: 0,
        fontWeight: "bold",
        display: true,
        unRepeated: false,
        title: "标题",
        fontSize: 30,
        color: "#000000",
        textAlign: "center",
        relationId: "",
      },
    ],
  },
  {
    title: "输入组件",
    list: [
      {
        type: "input",
        label: "单行文本",
        icon: "learun-icon-input-box",
        placeholder: "请输入",
        span: 24,
        patterns: [],
        display: true,
        unRepeated: false,
        default: "",
      },
      {
        type: "textarea",
        label: "多行文本",
        icon: "learun-icon-input-multi",
        placeholder: "请输入",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
      },
      // {
      //   type: "autocomplete",
      //   label: "带建议输入框",
      //   icon: "learun-icon-input-box",
      //   placeholder: "请输入",
      //   span: 24,
      //   patterns: [],
      //   display: true,
      //   unRepeated: false,
      //   default: "",
      //   default: "1",
      //   dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
      //   dataCode: "",
      //   dataValueKey: "",
      //   dataLabelKey: "",
      //   upCtrl: "",
      //   options: [
      //     {
      //       value: "1",
      //       label: "选项1",
      //     },
      //     {
      //       value: "2",
      //       label: "选项2",
      //     },
      //     {
      //       value: "3",
      //       label: "选项3",
      //     },
      //   ],
      // },
      {
        type: "texteditor",
        label: "编辑器",
        icon: "learun-icon-editor",
        placeholder: "请输入",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
      },
      {
        type: "neweditor",
        label: "高级编辑器",
        icon: "learun-icon-editor",
        placeholder: "请输入内容",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        height: 300,
        menubar: false,
        resize: true,
        statusbar: false,
        toolbar_mode: "sliding",
      },
      {
        type: "aiEditor",
        label: "AI编辑器",
        icon: "learun-icon-editor",
        placeholder: "请输入内容",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        height: 300,
        menubar: false,
        resize: true,
        statusbar: false,
        toolbar_mode: "sliding",
      },
      {
        type: "number",
        label: "计数器",
        icon: "learun-icon-digital-input",
        placeholder: "请输入",
        controlsPosition: "default",
        controls: true,
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        disabled: false,
      },
      {
        type: "password",
        label: "密码",
        icon: "learun-icon-password-input",
        placeholder: "请输入",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
      },
      {
        type: "count",
        label: "计算组件",
        icon: "learun-icon-password-input",
        placeholder: "请输入",
        span: 24,
        display: true,
        unRepeated: false,
        disabled: true,
        default: "",
        isNotSave: false,
        formatJson: [],
      },
      {
        type: "num",
        label: "数字",
        icon: "learun-icon-time",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        disabled: false,
        placeholder: "请输入数字",
        fix: "", // 小数位
        unit: "", // 单位
        appendUnit: false, // 单位显示在后面
        units: [], // 可选单位
        readonly: false, // 是否只读
        upperCase: false, // 金额大写
        money: false, // 打印显示金额千分位
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        unitCode: "", //单位绑定字段
      },
      {
        type: "scanCode",
        label: "扫码组件",
        icon: "el-icon-full-screen",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        disabled: false,
        placeholder: "",
        dataApi: "", // 数据接口
        dataTable: [], // 主表组件数据映射表
        dataChildTable: [], // 子表组件数据映射表
        readonly: false, // 是否只读
      },
      {
        type: "invoiceRecognition",
        label: "发票识别",
        icon: "el-icon-full-screen",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        disabled: false,
        placeholder: "",
        readonly: false, // 是否只读
      },
      {
        type: "exam",
        label: "",
        title: "考核组件",
        icon: "learun-icon-star",
        span: 24,
        labelWidth: 0,
        display: true,
        unRepeated: false,
        default: "",
        disabled: false,
        placeholder: "",
        readonly: false, // 是否只读
        columns: [],
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        values: [],
        ParamJsonList: [],
      },
    ],
  },
  {
    title: "选择组件",
    list: [
      {
        type: "radio",
        label: "单选框组",
        icon: "learun-icon-radio",
        span: 24,
        display: true,
        unRepeated: false,
        default: "1",
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        upCtrl: "",

        options: [
          {
            value: "1",
            label: "选项1",
          },
          {
            value: "2",
            label: "选项2",
          },
          {
            value: "3",
            label: "选项3",
          },
        ],
      },
      {
        type: "checkbox",
        label: "多选框组",
        icon: "learun-icon-checkbox",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        upCtrl: "",
        options: [
          {
            value: "1",
            label: "选项1",
          },
          {
            value: "2",
            label: "选项2",
          },
          {
            value: "3",
            label: "选项3",
          },
        ],
      },
      {
        type: "select",
        label: "下拉选择",
        icon: "learun-icon-select",
        span: 24,
        display: true,
        unRepeated: false,
        placeholder: "请选择",

        default: "",
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        upCtrl: "",
        searchList: [],
        seachLoopUp: false,
        allowCreate: false,
        params: "",
        timmer: "",
        remoteParams: "",
        httpUrl: "",
        httpWay: "",
        assemblyID: "",
        options: [
          {
            value: "1",
            label: "选项1",
          },
          {
            value: "2",
            label: "选项2",
          },
          {
            value: "3",
            label: "选项3",
          },
        ],
      },
      {
        type: "selectMultiple",
        label: "下拉多选",
        icon: "learun-icon-select-multi",
        span: 24,
        display: true,
        unRepeated: false,
        multiple: true,
        allowCreate: false,
        placeholder: "请选择",

        default: "",
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        upCtrl: "",
        collapseTags: false,
        options: [
          {
            value: "1",
            label: "选项1",
          },
          {
            value: "2",
            label: "选项2",
          },
          {
            value: "3",
            label: "选项3",
          },
        ],
      },
      {
        key: 1,
        type: "treeselect",
        label: "树形选择",
        icon: "learun-icon-tree-select",
        span: 24,
        display: true,
        unRepeated: false,
        placeholder: "请选择",

        default: "",
        dataType: "1", // 1 静态数据 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        dataIdKey: "",
        dataPIdKey: "",
        upCtrl: "",
        options: [
          {
            label: "选项一",
            value: "0",
            children: [
              {
                label: "选项1-1",
                value: "11",
              },
              {
                label: "选项1-2",
                value: "12",
              },
            ],
          },
          { label: "选项二", value: "1" },
          { label: "选项三", value: "2" },
        ],
      },
      {
        type: "layerselect",
        label: "弹窗选择",
        icon: "learun-icon-popup-window",
        span: 24,
        placeholder: "请选择",
        display: true,
        unRepeated: false,
        notChangeForm: false, // 值改变不刷新表单
        multiple: false,
        isPage: true,
        columns: [],
        height: 504,
        width: 960,

        default: "",
        dataType: "2", // 2 数据字典 3 远端数据
        dataCode: "",
        dataValueKey: "",
        dataLabelKey: "",
        upCtrl: "",
      },
      /*,{
                key:1,
                type: 'cascader',
                label: '级联选择',
                icon: 'fa fa-share-alt',
                span: 24,
                display: true,
                unRepeated: false,
                placeholder:'请选择',

                default:[],
                dataType:'1', // 1 静态数据 2 数据字典 3 远端数据
                dataCode:'',
                dataValueKey:'',
                dataLabelKey:'',
                options: [
                    {
                        label: '选项一',
                        value: '0',
                        children: [{
                            label: '选项1-1',
                            value: '11',
                        }, {
                            label: '选项1-2',
                            value: '12',
                        }]
                    },
                    { label: '选项二', value: '1' },
                    { label: '选项三', value: '2' },
                ]
            }*/

      {
        type: "time",
        label: "时间选择",
        icon: "learun-icon-time",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        placeholder: "选择时间",
        format: "HH:mm:ss",
        readonly: false,
        clearable: true,
        selectableRange: "",
      },
      {
        type: "timerange",
        label: "时间范围",
        icon: "learun-icon-time-range",
        span: 24,
        display: true,
        unRepeated: false,

        startPlaceholder: "开始时间",
        endPlaceholder: "结束时间",
        format: "HH:mm:ss",
        default: "",
        readonly: false,
        clearable: true,
        isRange: true,
      },
      {
        type: "datetime",
        label: "日期选择",
        icon: "learun-icon-date",
        span: 24,
        display: true,
        unRepeated: false,
        dateType: "date",
        format: "yyyy-MM-dd",
        readonly: false,
        clearable: true,
        placeholder: "选择日期",
        default: "",
      },
      {
        type: "datetimerange",
        label: "日期范围",
        icon: "learun-icon-date-range",
        span: 24,
        display: true,
        unRepeated: false,
        isRange: true,
        dateType: "daterange",

        startPlaceholder: "开始时间",
        endPlaceholder: "结束时间",
        format: "yyyy-MM-dd",
        readonly: false,
        clearable: true,
        default: "",
      },
      {
        type: "areaselect",
        label: "省市区",
        icon: "learun-icon-provinces",
        span: 24,
        placeholder: "请选择",
        display: true,
        unRepeated: false,

        default: "",
      },
      {
        type: "layerbmap",
        label: "地图选择",
        icon: "learun-icon-map",
        span: 24,
        placeholder: "请输入地址",
        display: true,
        unRepeated: false,

        bindaddr: "",
        bindaddrpoint: "",
        height: 504,
        width: 960,
      },
      {
        type: "processSelect",
        label: "流程选择",
        icon: "learun-icon-list",
        span: 24,
        placeholder: "请选择相关流程",
        display: true,
        unRepeated: false,
        bindaddr: "",
        bindaddrpoint: "",
        height: 504,
        width: 960,
        multiple: true,
        defaultKw: "",
      },
    ],
  },
  {
    title: "上传组件",
    list: [
      {
        type: "upload",
        label: "文件上传",
        icon: "learun-icon-file-upload",
        span: 24,
        display: true,
        unRepeated: false,
        maxSize: "2",
        sizeType: "MB",
        limit: 1,
        default: "",
      },
      {
        type: "uploadimg",
        label: "图片上传",
        icon: "learun-icon-image-upload",
        span: 24,
        display: true,
        unRepeated: false,
        listType: "picture-card",
        maxSize: "2",
        sizeType: "MB",
        limit: 9,
        default: "",
      },
    ],
  },
  {
    title: "系统组件",
    list: [
      {
        type: "guid",
        label: "GUID主键",
        icon: "learun-icon-guid",
        span: 24,
        display: false,
        default: "",
      },
      {
        type: "companySelect",
        label: "公司选择",
        icon: "learun-icon-co",
        span: 24,
        display: true,
        unRepeated: false,
        isLogin: false,
        default: "",
      },
      {
        type: "departmentSelect",
        label: "部门选择",
        icon: "learun-icon-department",
        span: 24,
        display: true,
        unRepeated: false,
        isLogin: false,
        default: "",
        multiple: false,
      },
      {
        type: "userSelect",
        label: "人员选择",
        icon: "learun-icon-user",
        span: 24,
        display: true,
        showBorder: true,
        unRepeated: false,
        isLogin: false,
        multiple: false,
        default: "",
      },
      {
        type: "roleSelect",
        label: "角色选择",
        icon: "learun-icon-user",
        span: 24,
        display: true,
        unRepeated: false,
        isLogin: false,
        default: "",
      },
      {
        type: "postSelect",
        label: "岗位选择",
        icon: "learun-icon-personnel",
        span: 24,
        display: true,
        unRepeated: false,
        isLogin: false,
        default: "",
      },

      {
        type: "company",
        label: "所属公司",
        icon: "learun-icon-co",
        span: 24,
        display: false,
        default: "",
      },
      {
        type: "department",
        label: "所属部门",
        icon: "learun-icon-department",
        span: 24,
        display: false,
        default: "",
      },
      {
        type: "createuser",
        label: "创建人员",
        icon: "learun-icon-user",
        span: 24,
        display: false,
        default: "",
        showWokerNumber: false,
      },
      {
        type: "modifyuser",
        label: "修改人员",
        icon: "learun-icon-user",
        span: 24,
        display: false,
        default: "",
      },
      {
        type: "createtime",
        label: "创建时间",
        icon: "learun-icon-time",
        span: 24,
        display: false,
        default: "",
      },
      {
        type: "modifytime",
        label: "修改时间",
        icon: "learun-icon-time",
        span: 24,
        display: false,
        default: "",
      },
      {
        type: "encode",
        label: "单据编码",
        icon: "learun-icon-doc-code",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
        code: "",
      },
      {
        type: "auditLog",
        label: "",
        icon: "learun-icon-log",
        span: 24,
        placeholder: "暂无相关审批记录",
        labelWidth: 0,
        display: true,
        unRepeated: false,
        isNotSave: true,
        default: "",
        processId: "",
        nodeId: "",
        title: "审批记录",
      },
    ],
  },
  {
    title: "视图组件",
    list: [
      {
        type: "viewtable",
        label: "视图表格",
        icon: "learun-icon-view-form",
        span: 24,

        display: true,
        unRepeated: false,
        paramFiled: "",
        dataCode: "",
        columns: [],
        ParamJsonList: [],
      },
      {
        type: "qrcode",
        label: "二维码",
        icon: "learun-icon-bar-code",
        span: 24,
        default: "",
        display: true,
        unRepeated: false,
        disabled: false,
        size: 120,
        margin: 0,
        color: "#000000",
        background: "#FFFFFF",
        format: "qr",
        bindingType: 2,
      },
      {
        type: "barcode",
        label: "一维码",
        icon: "learun-icon-bar-code",
        span: 24,
        default: "",
        display: true,
        unRepeated: false,
        disabled: false,
        format: "CODE39",
        height: 20,
        width: 2,
        displayValue: true,
        fontOptions: "",
        background: "#FFFFFF",
        textAlign: "left",
        textPosition: "bottom",
        color: "#000000",
        margin: 10,
        bindingType: 2,
      },
    ],
  },
  {
    title: "操作组件",
    list: [
      {
        type: "btn",
        label: "按钮组件",
        icon: "learun-icon-button",
        span: 24,
        display: true,
        unRepeated: false,
        size: "mini",
        plain: false,
        round: false,
        circle: false,
        myIcon: "",
        myType: "",
      },
    ],
  },
  {
    title: "其它组件",
    list: [
      {
        type: "icon",
        label: "图标",
        icon: "learun-icon-icon",
        span: 24,
        display: true,
        unRepeated: false,
        default: "",
      },
      {
        type: "rate",
        label: "评分",
        icon: "learun-icon-star",
        span: 24,
        display: true,
        unRepeated: false,
        max: 5,
        disabled: false,
        allowHalf: false,
        lowThreshold: 2,
        highThreshold: 4,
        colors: ["#F7BA2A", "#F7BA2A", "#F7BA2A"],
        voidColor: "#C6D1DE",
        disabledVoidColor: "#EFF2F7",
        iconClasses: ["el-icon-star-on", "el-icon-star-on", "el-icon-star-on"],
        voidIconClass: "el-icon-star-off",
        disabledVoidIconClass: "el-icon-star-on",
        showText: false,
        showScore: false,
        textColor: "#1F2D3D",
        texts: ["极差", "失望", "一般", "满意", "惊喜"],
        default: 0,
      },
      {
        type: "switch",
        label: "开关",
        icon: "learun-icon-on-off",
        span: 24,
        display: true,
        unRepeated: false,
        disabled: false,
        width: 40,
        default: false,
        activeIconClass: "",
        inactiveIconClass: "",
        activeText: "",
        inactiveText: "",
        valueType: "boolean",
        activeValue: "true",
        inactiveValue: "false",
        activeColor: "#409EFF",
        inactiveColor: "#C0CCDA",
      },
      {
        type: "slider",
        label: "滑块",
        icon: "learun-icon-sliding",
        span: 24,
        display: true,
        unRepeated: false,
        default: 0,
        min: 0,
        max: 100,
        step: 1,
        showInput: false,
        showInputControls: true,
        showStops: false,
        showTooltip: true,
      },
      {
        type: "color",
        label: "颜色选择",
        icon: "learun-icon-color",
        span: 24,
        default: "",
        display: true,
        unRepeated: false,
        disabled: false,
      },
      {
        type: "txt",
        label: "标签描述",
        icon: "learun-icon-input-textfield",
        span: 24,
        default: "",
        txt: "请输入描述文案",
        css: "",
        display: true,
        unRepeated: false,
        disabled: false,
      },
      {
        type: "img",
        label: "图片展示",
        icon: "learun-icon-upload-image-upload",
        span: 24,
        folderId: "",
        url: "",
        maxHeight: 400,
        display: true,
        unRepeated: false,
        css: "",
        layout: 'center'
      },
      {
        type: "relatedTask",
        label: "关联任务",
        icon: "learun-icon-list",
        span: 24,
        placeholder: "",
        display: true,
      },
    ],
  },
];
